module.exports = __webpack_public_path__ + "static/media/adicionado.7a760b5a.svg";